import { PASSWORD_TEXT_FIELD_STRENGTH_THRESHOLD } from "../PasswordTextField";

const PASSWORD_LENGHTS = [8, 10];

const PASSWORD_REGEX = [/[A-Z]/ /*Uppercase*/, /[a-z]/ /*Lowercase*/, /[0-9]/ /*Number*/, /[\W_]/ /*Special Char*/];

export default function getPasswordProgress(password: string) {
    let progress = 0;
    PASSWORD_REGEX.forEach((regex) => {
        if (regex.test(password)) progress += PASSWORD_TEXT_FIELD_STRENGTH_THRESHOLD / PASSWORD_REGEX.length;
    });
    if (progress < PASSWORD_TEXT_FIELD_STRENGTH_THRESHOLD) return progress;
    PASSWORD_LENGHTS.forEach((lenght) => {
        if (password.length >= lenght) progress += (100 - PASSWORD_TEXT_FIELD_STRENGTH_THRESHOLD) / PASSWORD_LENGHTS.length;
    });

    return progress;
}
